import * as React from 'react';
import { TDirection } from '@cian/frontend-newbuilding-carousel-component';
import { ArrowL16, ArrowR16 } from '@cian/ui-kit/icons';
import classNames from 'classnames';

import * as styles from './styles.css';

export interface IVerticalArrowProps {
  direction: TDirection;
  offset?: number;
  containerClass?: string;
  onClick?(): void;
}

const DEFAULT_OFFSET = -20;

export function VerticalArrow({ direction, offset = DEFAULT_OFFSET, containerClass, onClick }: IVerticalArrowProps) {
  const ArrowIcon = direction < 0 ? ArrowL16 : ArrowR16;
  const style = direction < 0 ? { left: `${offset}px` } : { right: `${offset}px` };

  return (
    <div className={classNames(styles['arrow'], containerClass)} style={style} onClick={onClick}>
      <ArrowIcon color={'gray_icons_100'} />
    </div>
  );
}
